// Codice `tipo` del LECS -> nome commerciale.
export const mapTipoToDescrizione = (tipo) => {
  switch (tipo) {
    case "LECS+64":
      return "LECS BUSINESS";
    case "LECS-64":
      return "LECS ENTERPRISE";
    case "LECS-CORE-2":
      return "LECS CORE 2P";
    case "LECS-CORE-4":
      return "LECS CORE 4P";
    case "LECS-CORE-SFP":
      return "LECS CORE SFP";
    default:
      return "LECS CUSTOM";
  }
};
